import React from "react";
import "../../assets/css/Spinner.css";

export const Spinner = ({ size = 50 }) => {
  return (
    <div
      id="spinner_loader"
      className="loader-container"
      style={{ width: size, height: size }}
    >
      <div className="loader" style={{ width: size, height: size }} />
    </div>
  );
};
